import React, { useState, useRef, useEffect } from 'react';
import UploadClientsListFileController from '../../../../Controllers/AdminScreens/Services/Settings/UploadClientsListFileController';
import downArrow from '../../../../../Assets/Icons/chevron-down.png';
import plusIcon from '../../../../../Assets/Icons/Pluse.png';
import uploadIcon from '../../../../../Assets/Icons/upload.png';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../../../Components/Loader';
import Dropdown from '../../../../../Components/Dropdown';
import { convertGMTToLocal } from '../../../../../Utils/Validation';

const UploadClientsListFileScreen = ({importMasterListLoading,importMasterList,importMasterListError,onRefresh}) => {
    const navigate = useNavigate();
    const fileInputRef = useRef(null);
    const {
        tasks,
        currentPage,
        totalPages, visiblePages,
        handlePageChange,
        handleFileChange,
        importMasterSuccess,
        importMasterLoading,
        importMasterError,
        downloadFile,
        handleImportMasterTemplates,
        importMasterTemplatesLoading,
        importMasterTemplateError
    } = UploadClientsListFileController(importMasterList,onRefresh,fileInputRef );

    const handleFileUploadClick = () => {
        fileInputRef.current.click();
    };

    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
        const toggleDropdown = (dropdownName) => {
            setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
        };
    
        const dropdownRefs = useRef({}); // Ref for dropdown
    
        // Handle clicks outside dropdowns
        useEffect(() => {
            const handleClickOutside = (event) => {
                const isOutside = Object.keys(dropdownRefs.current).every(
                    (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
                );
                if (isOutside) {
                    setOpenDropdown(null);
                }
            };
    
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, []);
        const deliveryTypeOptions = ["Bulk Client Upload", "Bulk Task Upload", "Opening Balance"];

        const handleDrop = (e) => {
            const files = e.dataTransfer.files; // Get the files from the drop event
            if (files && files.length > 0) {
              //console.log("Dropped files:", files);
              handleFileChange({ target: { files } }); // Reuse handleFileChange for processing
            }
          };

          const getStatusStyle = (status) => {
            switch (status) {
             case 'Completed' :
                return { backgroundColor: "rgba(26, 147, 46, 0.18)", color: "rgba(26, 147, 46, 1)" };
              case 'Pending':
                //Disabled
                return { backgroundColor: "rgba(238, 32, 28, 0.18)", color: "rgba(238, 32, 28, 1)" };
              case 'Failed':
                //Disabled
                return { backgroundColor: "rgba(238, 32, 28, 0.18)", color: "rgba(238, 32, 28, 1)" };
            case 'Partially successful':
                //Disabled
                return { backgroundColor: "rgba(226, 177, 51, 0.18)", color: "rgba(223, 165, 16, 1)" };
              default:
                return {};
            }
          };

          const formatDate = (dateString) => {
            if (!dateString) return '--';
            const [year, month, day] = dateString.split('-');
            return `${day}/${month}/${year}`;
        };
        const handleDropdownChange = (option) => {
            handleImportMasterTemplates(option);
        };


    return (
        <>
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', textAlign:'center'}}> 
                <h2 className="tasksScreen-tasks-title">Import Clients</h2>
                <Dropdown
                        ref={(el) => (dropdownRefs.current["Download Template"] = el)}
                        isOpen={openDropdown === "Download Template"}
                        toggleDropdown={() => toggleDropdown("Download Template")}
                        label="Download Template"
                        options={deliveryTypeOptions}
                        searchBoxWidth={200}
                        onChange={handleDropdownChange}
                        loading={importMasterTemplatesLoading}
                        errorMessage={importMasterTemplateError}
                    />
            </div>
            <div
                style={{
                    position: "relative",
                    border: "1px dashed var(--web-title-text-color)",
                    borderRadius: "10px",
                    padding: "35px",
                    textAlign: "center",
                    backgroundColor: "#fff",
                    marginBottom: "50px",
                    marginTop: "15px",
                    pointerEvents : importMasterLoading ? 'none' : 'auto'
                }}
                onDragOver={(e) => e.preventDefault()} // Prevent default drag behavior
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleDrop(e);
            }}
            >
                <div
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        cursor: "pointer",
                    }}
                    onClick={handleFileUploadClick}
                >
                    <img src={uploadIcon} alt="Upload Icon" style={{ width: "20px", height: "20px" }} />
                </div>
                <div onClick={handleFileUploadClick} style={{ cursor: "pointer" }}>
                    <div
                        style={{
                            width: "60px",
                            height: "60px",
                            margin: "auto",
                            backgroundColor: "#F2F2F2",
                            borderRadius: "25%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <img src={plusIcon} alt="Plus Icon" style={{ width: "30px", height: "30px", filter: 'brightness(0)' }} />
                    </div>
                    <p style={{ margin: "10px 0", color: "#262626", fontWeight: '500', fontSize: '14px' }}>
                        Drag or Upload xlsx file to import clients, max size 2 MB
                    </p>
                    <p style={{ margin: "10px 0", color: "#262626", fontWeight: '500', fontSize: '14px' }}>
                        Please upload records up to 500.
                    </p>
                    {importMasterError && <div className="list-error-msg">{importMasterError} </div>}
                    {importMasterSuccess && <div className="list-success-msg" style={{ marginBottom: '3px' }}>{importMasterSuccess} </div>}
                    {importMasterLoading && <Loader loading={importMasterLoading} color={'var(--primary-color)'} />}
                </div>
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                />
            </div>
            <div className="tasksScreen-tasks-header">
                <h2 className="tasksScreen-tasks-title" style={{ fontSize: "18px" }}>Upload History</h2>
            </div>

            <div className="tasksScreen-task-table-wrapper">
                <table className="tasksScreen-task-table">
                    <thead>

                        {/* Table Headers */}
                        <tr>
                            <th style={{ width: "30%", }}>Upload Item</th>
                            <th style={{ width: "45%", }}>Date</th>
                            <th style={{ width: "15%", }}>Imported By</th>
                            <th style={{ width: "15%", }}>Status</th>
                        </tr>
                    </thead>
                    <tbody style={{ backgroundColor: '#fff' }}>
                        {tasks?.map((task, index) => (
                            <tr key={index}>
                                <td
                                    style={{
                                        textDecoration: "underline",
                                        color: "#5A55D2",
                                        cursor: "pointer",
                                    }}
                                >
                                    {task?.import_name}
                                </td>
                                <td>{convertGMTToLocal(task?.import_time,"dd/MM/yyyy")}</td>
                                <td>{task?.import_by_name}</td>
                                <td>
                                    <span
                                        style={{
                                            display: "inline-block",
                                            padding: "5px 10px",
                                            borderRadius: "15px",
                                            ...getStatusStyle(task?.upload_status_name),
                                        }}
                                    >
                                        {task?.upload_status_name}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {importMasterListError && <div className="list-error-msg">{importMasterListError} </div>}
                    {importMasterListLoading && <Loader loading={importMasterListLoading} color={'var(--primary-color)'} />}
            </div>

            <div className="tasksScreen-table-footer">
                <span className="tasksScreen-pagination-info">
                    {`${currentPage}-${totalPages} of items`}
                </span>
                <div className="tasksScreen-pagination">
                    <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>
                        <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image " />
                    </button>
                    {visiblePages.map((page) => (
                        <button
                            key={page} className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                            onClick={() => handlePageChange(page)}> {page}
                        </button>
                    ))}
                    <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
                        <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image " />
                    </button>
                </div>
            </div>
        </>
    );
};


export default UploadClientsListFileScreen;
